<template>
  <header id="head" class="box-header_nomal maching_header">
    <div class="inner box-header_inner">
      <h1><a href="/matching/"><img src="../assets/img/logo/ttl-logo_shindan.png" width="230" height="22"
            alt="推し家診断 OSHIIE SHINDAN" /></a></h1>
            <ul class="lst-link_nav_header">
              <li class="bg-request"><a href="https://area18.smp.ne.jp/area/switch/00011K00053Aeeq0Ka/catalog" target="_blank">資料請求</a></li>
              <li class="bg-reserve"><a href="https://35s.co.jp/chukyotvh/menu/reservation/" target="_blank">見学予約</a></li>
              <li class="bg-company"><a href="https://100ie-jiten.com/" target="_blank">建築事例いっぱい<img src="../assets/img/logo/ttl-logo_hyakka.png" width="" height="" alt="百家辞典"></a></li>
          </ul>
    </div>
  </header>
</template>
<script>
export default {
  name: 'HeaderSelect',
  props: {
    msg: String
  }
}
</script>